import { sortArrByArr } from '@apprentage/utils';
import { client, flattenItems } from './contentful';

export const fetchTopics = ({ classId, topicIds }) => {
  const config = {
    content_type: 'topic',
    include: 1,
    'fields.classId': classId
  };

  return new Promise((resolve, reject) => {
    client
      .getEntries(config)
      .then((rsp) => {
        const hasItems = Array.isArray(rsp?.items) && rsp.items.length > 0;
        const hasTopicIds = Array.isArray(topicIds) && topicIds.length > 0;
        const items = hasItems ? flattenItems(rsp?.items) : null;
        let list = items;

        if (hasItems && hasTopicIds) {
          list = sortArrByArr(items, topicIds, 'id');
        }

        resolve({
          list,
          count: rsp?.total
        });
      })
      .catch((error) => {
        console.error('fetchTopics', error);
        reject(error);
      });
  });
};
